const FAQS = [
  {
    q: "01. How do I sign up for closet?",
    a: "Download the closet app from the App Store or Google Play. You can create an account using your email or social media account.",
  },
];

export default FAQS;
